export default __webpack_public_path__ + "static/media/ProductPageImage03.c6eefd0c.jpg";